export default "__VITE_ASSET__Cegk2Oqg__"